import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import materialGroupService from "../../../../../../../services/web/material-group-service.js";
import {useQuery} from "@tanstack/react-query";
import {Modal} from "../../../../../../../components/modal/modal.jsx";
import aggridUtils from "../../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../../components/button/button.jsx"
import InputForm from "../../../../../../../components/input/input-form.jsx";
import {FaEraser} from "react-icons/fa";
import {normalizeFilterText} from "../../../../../../../utils/normalizeFilterText.js";
import GenericEditRemoveCellRenderer
    from "../../../../../agents/form/components/tabs/generic-edit-remove-cell-renderer.jsx";

const ModalGroups = ({groups, modal, setModal, setGroups}) => {
    const gridRef = useRef(null);
    const [selected, setSelected] = useState([]);
    const [filter, setFilter] = useState("")
    const [groupsList, setGroupsList] = useState([])

    const [columnDefs] = useState([
        {headerName: "Descrição", field: "label", flex: 1, getQuickFilterText: ({value}) => normalizeFilterText(value)},
    ]);

    useQuery({
        queryKey: ['materials-groups'],
        queryFn: async () =>  {
            return  materialGroupService.options().then(data => {
                setGroupsList(data.filter(o => {
                    const find = groups.find(g => g.id === o.value)
                    return !find;
                }))

                return []
            })
        },
        initialData: [],
        enabled: modal
    });

    const rowSelection = useMemo(() => {
        return {
            mode: "multiRow",
            headerCheckbox: false,
            enableSelectionWithoutKeys: true,
            enableClickSelection: true,
        };
    }, []);

    const onGridReady = (params) => {
        if (!selected.size) return;

        const nodes = [];
        params.api.forEachNode(node => {
            if (selected.has(node.data)) {
                nodes.push(node);
            }
        });

        params.api.setNodesSelected({ nodes, newValue: true });
    }

    const changeFilter = (value) => {
        const normalized = normalizeFilterText(value);

        setFilter(value)
        onFilterTextBoxChanged(normalized);
    }

    const onFilterTextBoxChanged = useCallback((value) => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            value,
        );
    }, []);

    const closeModal = () => {
        setFilter("");
        setModal(false);
        setSelected([])
    }

    const addSelected = () => {
        setGroups(prev => [...(selected.map(s => ({id: s.value, description: s.label, new: true}))), ...prev]);
        closeModal();
    }

    const addAll = () => {
        const groupsToAdd = [];
        gridRef.current.api.forEachNode(node => groupsToAdd.push({id: node.data.value, description: node.data.label, new: true}));

        setGroups(prev => [...groupsToAdd, ...prev]);
        closeModal();
    }

    const onRowSelected = ({data}) => {
        setSelected(prev => {
            const find = prev.find(p => p.value === data.value)

            if (find) {
                return prev.filter(p => p.value !== data.value)
            }

            data.new = true
            return [...prev, data]
        })
    }

    return (
        <Modal alignTop={true} open={modal} setOpen={setModal} title={"Grupos permitidos"} className={"w-5/12"}>
            <Modal.Body>
                <div className={"col-span-12 flex gap-4 mb-3"}>
                    <InputForm
                        classNameWrapper={"w-full"}
                        id="description"
                        name="description"
                        value={filter.description}
                        onChange={({target: {value}}) => changeFilter(value)}
                        label="Descrição"/>
                    <div>
                        <Button target={"primary-outline"} onClick={() => changeFilter("")}>
                            <FaEraser/>
                        </Button>
                    </div>
                </div>
                <div className={"max-h-[calc(100vh-291px)] aggrid-row-pointer"}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={groupsList}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                        domLayout='autoHeight'
                        rowSelection={rowSelection}
                        onRowSelected={onRowSelected}
                        onGridReady={onGridReady}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button target={"primary-outline"} onClick={addAll}>
                    Adicionar todos
                </Button>
                {
                    selected.length &&
                    <Button target="primary" onClick={addSelected}>
                        Adicionar {selected.length} grupo(s)
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default ModalGroups;